export default function csvToObject (csvString, headerFunc = null) {
  const rows = csvString.trim().split('\n')
  const headers = rows[0].split(',')
  if (!headerFunc) {
    headerFunc = header => header.trim()
  }
  const data = rows.slice(1).map(row => {
    const values = row.split(',')
    const obj = {}
    headers.forEach((header, index) => {
      let value = values[index].trim();
      if (!isNaN(value) && value !== '') {
        value = parseFloat(value);
      }
      obj[headerFunc(header)] = value;
    })
    return obj;
  })
  return data;
}
